import {createContext, useEffect, useState} from "react";
import {ItemLink} from "../components/footer/Footer";

export interface AppTitle {
    title: ItemLink[];
    updateAppTitle: (newTitle: ItemLink[]) => void;
    updateAppSuffix: (suffix: string) => void;
}

const useAppTitle = (initTitle: string): AppTitle => {
    const [title, setTitle] = useState<ItemLink[]>([{title: initTitle, href: '#'}] as ItemLink[]);
    const [suffix, setSuffix] = useState('');
    const appName = "Emprendedores";

    const updateAppTitle = (newTitle: ItemLink[]) => {
        setTitle(newTitle);
    };

    const updateAppSuffix = (suffix: string) => {
        setSuffix(suffix);
    }

    useEffect(() => {
        document.title = [[title[0].title,suffix].join(' '),appName].join(' - ');
    }, [title]);

    return { title ,updateAppTitle, updateAppSuffix };
}

export default useAppTitle;